// Gsap
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default function initNavigationSurPageImage() {
    const navListImagesBlocks = document.querySelectorAll('.navigation-liste-images');
    const isMobile = window.matchMedia('(max-width: 767px)').matches;

    if (!navListImagesBlocks || isMobile) {
        return;
    }

    navListImagesBlocks.forEach((navListImagesBlock) => {
        const leftImage = navListImagesBlock.querySelector('.left-image .img-wrap');

        ScrollTrigger.create({
            trigger: leftImage,
            start: 'top top',
            end: () => `${navListImagesBlock.offsetHeight - leftImage.offsetHeight}px 40%`,
            pin: leftImage,
            pinSpacing: false,
            markers: false,
            anticipatePin: 1,
        });

        setTimeout(() => {
            ScrollTrigger.refresh();

            setTimeout(() => {
                ScrollTrigger.refresh();
            }, 2500);
        }, 1000);
    });

    const linksTo = document.querySelectorAll('[data-link-index]');
    const images = document.querySelectorAll('[data-image-index]');

    if (!linksTo || !images) {
        return;
    }

    linksTo.forEach((linkItem) => {
        linkItem.addEventListener('mouseenter', () => {
            const indexId = linkItem.dataset.linkIndex;

            linksTo.forEach((linkItem) => {
                if (linkItem.dataset.linkIndex === indexId) {
                    linkItem.classList.add('is-active');
                } else {
                    linkItem.classList.remove('is-active');
                }
            });

            images.forEach((imageItem) => {
                if (imageItem.dataset.imageIndex === indexId) {
                    imageItem.classList.add('is-active');
                } else {
                    imageItem.classList.remove('is-active');
                }
            });
        });
    });
}
